module.exports = __webpack_public_path__ + "static/media/cancel-icon.f079050d.svg";